import { createPortal } from "react-dom";
import { useScrollLock } from "@/hooks/useScrollLock";

export default function Overlay({ onClose, children, className = "max-w-lg", testid, z = "z-50" }) {
  useScrollLock(true);
  const root = document.querySelector(".App") || document.body;
  return createPortal(
    <div className={`fixed inset-0 ${z} bg-black/70 flex items-end md:items-center justify-center p-4`} onClick={onClose}>
      <div
        className={`glass rounded-3xl p-6 w-full max-h-[88vh] overflow-y-auto overscroll-contain ${className}`}
        onClick={(e) => e.stopPropagation()}
        data-testid={testid}
      >
        {children}
      </div>
    </div>,
    root
  );
}
